import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { dateMomentFormat } from 'v2/formatters/date';
import type { IPeriodSales } from 'v2/interfaces/dashboard';

import apiService from './api';
import type { ApiService } from './api';

class DashboardService {
  private isLoadingPeriodSales$ = new Rx.BehaviorSubject<boolean>(true);

  constructor(private apiService: ApiService) {}

  public getPeriodSalesGains(startDate: Date, endDate: Date): Rx.Observable<IPeriodSales> {
    this.isLoadingPeriodSales$.next(true);
    return this.apiService
      .get(
        `/dashboard/periodsalesgains?start_date=${dateMomentFormat(startDate)}&end_date=${dateMomentFormat(endDate)}`
      )
      .pipe(
        map(response => response.data),
        tap(() => this.isLoadingPeriodSales$.next(false))
      );
  }

  public getLoadingPeriodSales() {
    return this.isLoadingPeriodSales$;
  }
}

const dashboardService = new DashboardService(apiService);
export default dashboardService;
